import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { appDataActions, appDataSelector } from '../../features/appDataSlice';
import { customerDetailsSelector } from '../../features/customerSlice';
import { retrievePidAdvisory } from '../../utilities/ContentRetrieverUtilities';

// Module-level so a 'loading' status persisted by a page refresh mid-request cannot block a retry.
let inFlight = false;

// Loads the PID advisory content once per booking session; start-over and logout reset it.
export function usePidAdvisory(isLane: boolean) {

  const dispatch = useAppDispatch();
  const appData = useAppSelector(appDataSelector);
  const customer = useAppSelector(customerDetailsSelector);
  const status = appData.pidAdvisory?.status ?? 'idle';

  useEffect(() => {
    if (!isLane || status === 'loaded' || inFlight) return;

    inFlight = true;
    dispatch(appDataActions.setPidAdvisoryLoading());
    retrievePidAdvisory(customer, appData.apiConfig)
      .then(entries => dispatch(appDataActions.setPidAdvisory(entries)))
      .finally(() => { inFlight = false; });
  }, [isLane, status])
}
